import { render, staticRenderFns } from "./KnowledgeFaq.html?vue&type=template&id=b9d52a3c&scoped=true&"
import script from "./KnowledgeFaq.ts?vue&type=script&lang=ts&"
export * from "./KnowledgeFaq.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/knowledge/_knowledge.scss?vue&type=style&index=0&id=b9d52a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d52a3c",
  null
  
)

export default component.exports